import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("karmivo_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const saveSession = (role, data) => {
  localStorage.setItem("karmivo_token", data.token);
  localStorage.setItem("karmivo_user", JSON.stringify(data.user));
  localStorage.setItem("karmivo_role", role);
};
export const clearSession = () => {
  localStorage.removeItem("karmivo_token");
  localStorage.removeItem("karmivo_user");
  localStorage.removeItem("karmivo_role");
};
export const currentUser = () => {
  try { return JSON.parse(localStorage.getItem("karmivo_user") || "null"); } catch { return null; }
};
export const currentRole = () => localStorage.getItem("karmivo_role");

export const downloadFile = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};

export const SERVICES = [
  { key: "loading_unloading", label: "Loading & Unloading", icon: "truck", desc: "Trained workers for shifting, loading, and unloading goods." },
  { key: "daily_labour", label: "Daily Labour", icon: "hard-hat", desc: "General purpose daily wage workers for any site need." },
  { key: "tiles_work", label: "Tiles Work", icon: "layout-grid", desc: "Experienced masons for floor and wall tiling." },
  { key: "house_repair", label: "House Repair / Renovation", icon: "hammer", desc: "Skilled labour for repair, plaster, paint & renovation." },
];

export const WORKER_COUNT_OPTIONS = [
  { value: 1, label: "1 worker" },
  { value: 2, label: "2 workers" },
  { value: 5, label: "5 workers" },
  { value: 10, label: "10 workers" },
  { value: -1, label: "Entire Team" },
];

export const STATUS_META = {
  pending: { label: "Payment Pending", color: "amber" },
  processing: { label: "Processing", color: "amber" },
  successful: { label: "Payment Successful", color: "emerald" },
  failed: { label: "Payment Failed", color: "red" },
  cancelled: { label: "Cancelled", color: "slate" },
  created: { label: "Created", color: "slate" },
  finding_workers: { label: "Finding Workers", color: "blue" },
  partially_assigned: { label: "Partially Assigned", color: "blue" },
  fully_assigned: { label: "Fully Assigned", color: "emerald" },
  in_progress: { label: "In Progress", color: "orange" },
  completed: { label: "Completed", color: "emerald" },
};
